import { Nullable, WithID } from 'lib/types/common'

// mirrors AddressType in server/src/shared/models/contact-address.ts
export enum AddressType {
  Postal = 'postal',
}

export type LookupAddress = WithID & {
  type: string
  company: string
  lineOne: string
  lineTwo: string
  city: string
  countryCode: string
  postalCode: string
}

export type Address = WithID & Omit<Nullable<LookupAddress>, 'type' | 'company'>
